import { Hitz } from '@hitz/sdk'
import { ENV, GAME, IS_DEV } from '../env'
import { COMPLETED_STATUS, GAME_ID, GAME_VERSION, LEVEL_IDS, RULES_VERSION } from './release.js'

/** Standalone play (no host) only in a local dev build on loopback, outside any iframe: the exception of the standard (spec §2.3). */
const LOCAL_DEVELOPMENT = IS_DEV && import.meta.env.DEV && typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)

/** Single SDK instance for the whole game (Hitz wire v1). Scenes request attempts and report actions through it. */
export const hitz = new Hitz({
  gameId: GAME_ID,
  version: GAME_VERSION,
  rulesVersion: RULES_VERSION,
  levels: LEVEL_IDS,
  capabilities: GAME.capabilities,
  // This title observes pause: the contract (config/hitz-contract.json) says the clock stops with the tab hidden.
  autoPause: true,
  customEvents: GAME.customEvents,
  platformOrigins: ENV.platformOrigins,
  completedStatus: COMPLETED_STATUS,
  strict: IS_DEV,
  debug: IS_DEV || new URLSearchParams(location.search).has('hitz_debug'),
  localDevelopment: LOCAL_DEVELOPMENT,
  standaloneAfterMs: 300
})
